import { render } from "./expDataDetails.vue?vue&type=template&id=f95e5ddc&scoped=true"
import script from "./expDataDetails.vue?vue&type=script&lang=js"
export * from "./expDataDetails.vue?vue&type=script&lang=js"

import "./expDataDetails.vue?vue&type=style&index=0&id=f95e5ddc&lang=less&scoped=true"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f95e5ddc"]])

export default __exports__